import axiosInstance from '../config/axios.js';

const API_BASE = '/vehicle-owners';

const vehicleOwnerService = {
  // Get all vehicle owners with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get vehicle owner by vehicle_owner_id
  getById: async (vehicleOwnerId) => {
    const response = await axiosInstance.get(`${API_BASE}/${vehicleOwnerId}`);
    return response.data;
  },

  // Create new vehicle owner
  create: async (ownerData) => {
    const response = await axiosInstance.post(API_BASE, ownerData);
    return response.data;
  },

  // Update vehicle owner
  update: async (vehicleOwnerId, ownerData) => {
    const response = await axiosInstance.put(`${API_BASE}/${vehicleOwnerId}`, ownerData);
    return response.data;
  },

  // Delete vehicle owner
  delete: async (vehicleOwnerId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${vehicleOwnerId}`);
    return response.data;
  },

  // Get vehicle owners by company (if needed)
  getByCompany: async (companyId, page = 1, perPage = 10) => {
    const response = await axiosInstance.get(`${API_BASE}`, {
      params: {
        company_id: companyId,
        page,
        per_page: perPage
      }
    });
    return response.data;
  },

  // Search vehicle owners
  search: async (searchTerm) => {
    const response = await axiosInstance.get(API_BASE, {
      params: { search: searchTerm }
    });
    return response.data;
  }
};

export default vehicleOwnerService;
